module.exports = __webpack_public_path__ + "img/4.6cb0abb7.png";